import { observer } from 'mobx-react-lite';
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom';


const ForParentsRecs: FC = () => {

    const navigate = useNavigate()

    return (
        <div className='row pt-2 m-3'>
            <h6 className='p-3 text-center'>Рекомендации для родителей</h6>
            <div className='col-md-3 text-center' onClick={() => navigate('/parents/recs/1/')} style={{ cursor: 'pointer' }}>
                <img src="/images/1.1.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Нарушения зрения</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/parents/recs/2/')} style={{ cursor: 'pointer' }}>
                <img src="/images/2.1.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Нарушения слуха</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/parents/recs/3/')} style={{ cursor: 'pointer' }}>
                <img src="/images/3.1.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Нарушения речи</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/parents/recs/4/')} style={{ cursor: 'pointer' }}>
                <img src="/images/4.1.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Нарушения опорно-двигательного аппарата</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/parents/recs/5/')} style={{ cursor: 'pointer' }}>
                <img src="/images/5.1.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Задержки психического развития</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/parents/recs/6/')} style={{ cursor: 'pointer' }}>
                <img src="/images/6.1.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Нарушения интеллекта</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/parents/recs/7/')} style={{ cursor: 'pointer' }}>
                <img src="/images/7.1.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Расстройства аутистического спектра</p>
            </div>
            <div className='col-md-3 text-center' onClick={() => navigate('/parents/recs/8/')} style={{ cursor: 'pointer' }}>
                <img src="/images/8.1.webp" alt="" className="img_wrap2"/>
                <p className='text-center fw-bold text-uppercase'>Другие заболевания</p>
            </div>
        </div>
    );
};

export default observer(ForParentsRecs);